import { LogbookActivityPayload, StateLogbook } from "../types";

export const logbookActivitySection = (state: StateLogbook, action: LogbookActivityPayload): StateLogbook => {
    return { ...state, activitySection: action.value }
}